// This file is automatically generated. Do not edit it directly.
import { createClient, navigatorLock } from '@supabase/supabase-js';
import type { Database } from './types';
import { logger } from '@/lib/logger';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

logger.log('Supabase Client Config:');
logger.log('URL:', SUPABASE_URL);
logger.log('Mode:', import.meta.env.MODE);

const waitForAuthLock = <Result,>(
	name: string,
	acquireTimeout: number,
	callback: () => Promise<Result>,
) => navigatorLock(name, acquireTimeout === 0 ? 5000 : acquireTimeout, callback);

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
	auth: {
		lock: waitForAuthLock,
	},
});